import React, { useState } from "react";
import { mainCategory } from "../data/mainCategory";
import { menLevelTwo } from "../data/levelTwo/menLevelTwo";
import { womenLevelTwo } from "../data/levelTwo/womenLevelTwo";
import { electronicsLevelTwo } from "../data/levelTwo/electronicsLevelTwo";
import { furnitureLevelTwo } from "../data/levelTwo/funitureLevelTwo";
import { beautyLevelTwo } from "../data/levelTwo/beautyLevelTwo";
import { menLevelThree } from "../data/levelThree/menLevelThree";
import { womenLevelThree } from "../data/levelThree/womenLevelThree";
import { electronicsLevelThree } from "../data/levelThree/electronicLevelThree";
import { furnitureLevelThree } from "../data/levelThree/funitureLevelThree";
import { beautyLevelThree } from "../data/levelThree/beautyLevelThree";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../State/Store";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

//Imagine the instructor is building a component that displays a multi-level navigation menu. Each level of categories needs to be loaded dynamically. By organizing data into separate objects for level two and level three, it becomes straightforward to map and render them conditionally.
//
export const categoryTwo: { [key: string]: any[] } = {
  men: menLevelTwo,
  women: womenLevelTwo,
  electronics: electronicsLevelTwo,
  home_furniture: furnitureLevelTwo,
  beauty: beautyLevelTwo,
};
export const categoryThree: { [key: string]: any[] } = {
  men: menLevelThree,
  women: womenLevelThree,
  electronics: electronicsLevelThree,
  home_furniture: furnitureLevelThree,
  beauty: beautyLevelThree,
};
type categorySheetProps = {
  selectedCategory: string | null;
  showCategory: boolean;
  setShowCategory: React.Dispatch<React.SetStateAction<boolean>>;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLButtonElement | null>>;
};
//
export const CategorySheet = ({
  selectedCategory,
  showCategory,
  setShowCategory,
  setAnchorEl,
}: categorySheetProps) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
 
  const { product } = useAppSelector((store) => store);
  const [selectedCatTwo, setSelectedCatTwo] = useState<string | null>(null);
  const level2 = selectedCategory ? categoryTwo[selectedCategory] ?? [] : [];
  const level3All = selectedCategory
    ? categoryThree[selectedCategory] ?? []
    : [];
  const navigate = useNavigate();
  // categoryId for levelTwo match with levelThree by categoryId but levelThree match with levelTwo is ParentCategory
  const childCategory = (category: any, categoryId: any) => {
    return category.filter(
      (child: any) => child.parentCategoryId == categoryId
    );
  };
  const handleShowProductPage = (item: any) => {
    setAnchorEl(null);
    setShowCategory(false);
    navigate("/products/" + item.categoryId);
  };

  const handleClickMob = (id: string) => {
    setSelectedCatTwo((prev) => (prev === id ? null : id)); // toggle
  };
  return (
    <>
      {isLarge ? (
        <Box className="bg-white shadow-lg  overflow-y-auto">
          <div className=" text-sm flex flex-wrap">
            {/* Yes, using categoryTwo["men"] to access the "Men" category data helps you dynamically select categories without having to use an exact index, which is a more flexible and maintainable approach. */}
            {level2?.map((item, index) => (
              <div
                key={index}
                className={`p-8 lg:w-[20%] ${
                  index % 2 === 0 ? "bg-slate-50" : "bg-white"
                }`}
              >
                <p className="text-primary mb-5 font-semibold">{item.name}</p>
                <ul className="space-y-3">
                  {childCategory(level3All, item.categoryId).map(
                    (item: any, index: any) => (
                      <div key={index} className="">
                        <li
                          onClick={() => {
                            handleShowProductPage(item);
                          }}
                          className="hover:text-primary cursor-pointer"
                        >
                          {item.name}
                        </li>
                      </div>
                    )
                  )}
                </ul>
              </div>
            ))}
          </div>
        </Box>
      ) : (
        <div className="py-2">
          {level2?.map((item, i) => {
             const isOpen = selectedCatTwo === item.categoryId; 
            return (
              <div key={i}>
                <button
                  className="text-primary my-4 font-semibold"
                  onClick={() => {
                    handleClickMob(item.categoryId);
                  }}
                >
                  <span>{item.name}</span>
                  {selectedCatTwo === item.categoryId ? (
                    <ExpandMoreIcon fontSize="small" />
                  ) : (
                    <ChevronRightIcon fontSize="small" />
                  )}
                </button>
                {isOpen && selectedCatTwo === item.categoryId && (
                  <>
                    {level3All
                      ?.filter((c) => c.parentCategoryId === selectedCatTwo)
                      .map((c) => (
                        <ul className="" key={c.categoryId}>
                          {
                            <li
                              onClick={() => {
                                handleShowProductPage(c);
                              }}
                              className="py-3 cursor-pointer hover:text-primary"
                            >
                              {c.name}
                            </li>
                          }
                        </ul>
                      ))}
                  </>
                )}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
